import { Api } from '@/utils';
import { getTreeData, filterShowTreeData, formatShowTreeData } from './utils';

export async function postRecordList({
  pageNum = 1,
  pageSize = 1000,
  app_id = 'base',
  model_id,
  conditionType = '=',
  ...others }: any): Promise<any> {
  const keys = Object.keys(others).filter((key: string) => key);
  let str = '';
  if (conditionType === '=') {
    str = keys.map((key: string) => `${key} ${conditionType} \${${key}} `).join(' AND ');
  } else if (conditionType === 'in') {
    str = keys.map((key: string) => `${key} ${conditionType}( \${${key}}) `).join(' AND ');
  } else {
    str = keys.map((key: string) => `${key} ${conditionType} '%\${${key}}%' `).join(' AND ');
  }
  const [err, res] = await Api({
    method: 'post',
    url: `/api/gateway/metabase/api/v1/${app_id}/${model_id}/page`,
    data: {
      condition: keys.length > 0 ? str : '',
      pageNum,
      pageSize,
      parameters: others,
    },
  });
  return res?.data || {};
}

export const getShowTreeData = async (mainData: any, productCode: string) => {
  const productRes = await postRecordList({
    app_id: 'base',
    model_id: 'bd_bpart_product_classification',
    number: productCode,
  });
  const newProductName = productRes?.data[0]?.name;
  const number = mainData?.number;
  const listRes = await postRecordList({
    app_id: 'master_data',
    model_id: 'md_bbom_template_line',
    md_bbom_template_number: number,
  });
  const list = (listRes.data || []).filter((el: any) => !el.is_bpart_classification);
  const treeRes = await postRecordList({
    app_id: 'base',
    model_id: 'bd_material_classification',
  });
  const allList = treeRes.data.map((el: any) => {
    const idItem = list.find((item: any) => item.bd_material_classification_number === el.number);
    if (idItem) {
      idItem.product_type = el.product_type;
    }
    return {
      ...(idItem || {}),
      ...el,
      key: el.number,
      title: el.name,
      disabled: !idItem?.md_bbom_template_line_id,
    };
  });
  const newTreeData = getTreeData(allList, 'superior_number', 'number');
  const headData = (listRes.data || []).find((item: any) => item.bd_material_classification_number === productCode && item.is_bpart_classification === 'true');
  const bpartData = await postRecordList({
    app_id: 'base',
    model_id: 'bd_bpart_product_classification',
    number: productCode,
  });
  const allData = {
    ...headData,
    title: newProductName,
    key: productCode + 'true',
    number: productCode,
    product_type: bpartData?.data?.[0]?.product_type,
    children: newTreeData,
  };
  const keys = list.map((el: any) => el.bd_material_classification_number);
  const newData = filterShowTreeData(allData, keys);
  const newShowData = formatShowTreeData(newData);
  (listRes.data || []).filter((el: any) => el.is_bpart_classification).forEach((el: any) => {
    el.product_type = bpartData?.data?.[0]?.product_type;
  });
  return {
    treeList: listRes.data || [],
    treeData: newShowData,
  };
};

export const getMainData = async ({
  brandType = '',
  brandCode = '',
  productCode,
}: any) => {
  // const res = await postRecordList({
  //   app_id: 'master_data',
  //   model_id: 'md_bbom_template',
  //   bd_bpart_product_classification_number: productCode,
  //   bd_brand_classification_type_code: brandType,
  //   bd_brand_classification_number: brandCode,
  // });
  brandType = brandType || '';
  brandCode = brandCode || '';
  const searchParams: any = {
    app_id: 'master_data',
    model_id: 'md_bbom_template',
    bd_bpart_product_classification_number: productCode,
  };
  // if (brandType) {
  //   searchParams.bd_brand_classification_type_code = brandType;
  // }
  // if (brandCode) {
  //   searchParams.bd_brand_classification_number = brandCode;
  // }
  const res = await postRecordList(searchParams);
  // const mainData = (res?.data || []).find((item: any) => {
  //   return item.bd_brand_classification_type_code === brandType && item.bd_brand_classification_number === brandCode;
  // });
  const mainData = res?.data?.[0];
  console.log('mainData', mainData, res, brandType, brandCode);
  if (mainData) {
    const listData = await getShowTreeData(mainData, productCode);
    return {
      mainInfo: mainData,
      ...listData,
    };
  } else {
    return {
      mainInfo: {},
      treeData: undefined,
      treeList: [],
    };
  }
};

export const getShowTreeFromCpartData = async (data: any) => {
  const { bd_brand_classification_type_code: brandType, bd_brand_classification_number: brandCode, bd_bpart_product_classification_number: productCode } = data || {};
  const res = await getMainData({
    brandType,
    brandCode,
    productCode,
  });
  return res;
};

export const getShowTreeFromTypeAndBrand = async (data: any) => {
  const { product_brand: brandCode, product_class_code: productCode } = data || {};
  const brandRes = await postRecordList({
    app_id: 'base',
    model_id: 'bd_brand_classification',
    number: brandCode,
  });
  const brandType = brandRes?.data[0]?.brand_class;
  const res = await getMainData({
    brandType,
    brandCode,
    productCode,
  });
  return res;
};

export const getShowTreeFromTypeAndBrandV2 = async (data: any) => {
  const { product_brand: brandCode, slave_of_spu: productCode } = data || {};
  const brandRes = await postRecordList({
    app_id: 'base',
    model_id: 'bd_brand_classification',
    number: brandCode,
  });
  const brandType = brandRes?.data[0]?.brand_class;
  const res = await getMainData({
    brandType,
    brandCode,
    productCode,
  });
  return res;
};

export const getShowTreeFromCpartCode = async (data: any) => {
  const cpartCode = data?.cpart_code;
  const cpartRes = await postRecordList({
    app_id: 'master_data',
    model_id: 'md_cpart_product_base_info',
    product_code: cpartCode,
  });
  const cpartData = cpartRes?.data[0];
  const res = await getShowTreeFromCpartData(cpartData);
  return res;
};

const apiMap: any = {
  getShowTreeFromCpartCode,
  getShowTreeFromCpartData,
  getShowTreeFromTypeAndBrand,
  getShowTreeFromTypeAndBrandV2,
};

export const getShowTreeDataFromApiName = async (data: any, apiName: string) => {
  const treeApi: any = apiMap[apiName];
  return treeApi(data);
};

export const getRecordDetail = async ({ taskId, recordId }: any) => {
  const [err, res] = await Api({
    method: 'get',
    url: `/api/gateway/metabase/compose_batch/multi_level_query_records/taskId/${taskId}/recordId/${recordId}`,
  });
  return res;
};

export const featchTableData = async (code: string) => {
  const listRes = await postRecordList({
    app_id: 'master_data',
    model_id: 'md_cpart_product_base_info',
    product_code: code,
  });
  const list = listRes.data || [];
  const id = list[0]?.md_cpart_product_base_info_id;
  const detailRes = await getRecordDetail({
    taskId: 'TASK20221209134843676460',
    recordId: id,
  });
  const detailListData = detailRes?.response?.record[0]?.children || [];
  const detailData: any = {};
  detailListData.forEach((el: any) => {
    detailData[el.modelId] = (el.record || []).map((item: any) => item.value);
  });
  return {
    listValue: detailData,
    recordId: id,
  };
};

export default getShowTreeDataFromApiName;
